import React, { Fragment } from 'react';
import DeleteData from './DeleteData';

const DataDelete = () => {
    return (
        <Fragment>
            <DeleteData />
        </Fragment>
    );
};

export default DataDelete;
